import React from 'react';
import PropTypes from 'prop-types';
import Paragraph from '../paragraph';
import IconButton from '../icon-button';
import ColorCircle from '../color-circle';
import Tag from '../tag';
import HorizontalStack from '../horizontal-stack';

function ColorItem({
  resetTooltipLabel = '',
  onResetClick = null,
  onEditClick,
  title,
  color,
  tagLabel = '',
  opacity = 1,
}) {
  const handleResetClick = (e) => {
    e.stopPropagation();
    onResetClick();
  };

  return (
    <div className="ws-ui-color-item" onClick={onEditClick}>
      <div className="ws-ui-color-item__container">
        <Paragraph isClipped>{title}</Paragraph>
        {tagLabel && <Tag label={tagLabel} size="small" appearance="cta-secondary" />}
      </div>
      <HorizontalStack verticalAlign="center" align="right" gap="spacing-2-xs">
        {onResetClick && (
          <div className="ws-ui-color-item__icon-button">
            <IconButton
              glyph="reset"
              appearance="light"
              size="medium"
              label={resetTooltipLabel}
              onClick={handleResetClick}
            />
          </div>
        )}
        <ColorCircle color={color} opacity={opacity} size="medium" />
      </HorizontalStack>
    </div>
  );
}

ColorItem.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  opacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onResetClick: PropTypes.func,
  resetTooltipLabel: PropTypes.string,
  tagLabel: PropTypes.string,
};

export default ColorItem;
